import $ from "jquery";
import TrackingConsent from "./TrackingConsent";

var GoogleAdsAdapter = function () {
  this.conversionIds = [];

  // ============================================================
  this.register = function () {
    $(".js_tracking_ads_container").each((_, el) => {
      if (!this.conversionIds.includes($(el).data("id"))) {
        this.conversionIds.push($(el).data("id"));
      }
      $(el).remove();
    });
  };

  // ============================================================
  this.event = function (eventName, params = {}) {
    if (!this.conversionIds.length) return;
    if (eventName !== "conversion") return;

    TrackingConsent.setGtagConsent();

    this.conversionIds.forEach((id) => {
      gtag("event", "conversion", {
        send_to: id,
        ...params,
      });
    });
  };

  this.pageView = function (params = {}) {};
};

export default GoogleAdsAdapter;
